import { z } from 'zod';
import { isMongoId, withPaginationParams } from '../../helpers';
import { CalendarDay } from '../../../utils';
import { CurrencyCode } from 'further-types/lp/vehicle';

// Carry partner investor ID (carry partner) - hardcoded for now
const CARRY_PARTNER_INVESTOR_ID = '64c11118cd4f16d09c504205';

const validateCommitmentAmount = (
  data: { investorId: string; totalCommitmentLcy: number },
  ctx: z.RefinementCtx,
) => {
  const isQueryPartner = data.investorId === CARRY_PARTNER_INVESTOR_ID;
  if (isQueryPartner) {
    if (data.totalCommitmentLcy < 0) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['totalCommitmentLcy'],
        message: 'Commitment amount must be greater than or equal to 0',
      });
    }
  } else {
    if (data.totalCommitmentLcy < 0.01) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['totalCommitmentLcy'],
        message: 'Commitment amount must be greater than 0.01',
      });
    }
  }
};

export const GetCommitment = z.object({
  commitmentId: z.string().refine(isMongoId()),
  date: z.instanceof(CalendarDay).optional(),
});

export const CreateCommitment = z
  .object({
    vehicleId: z.string().refine(isMongoId()),
    investorId: z
      .string()
      .refine(isMongoId(), { message: 'Please select an investor' }),
    commitmentDate: z.date(),
    totalCommitmentLcy: z.number().min(0),
    capitalCommitmentLcy: z.number().min(0),
    loanCommitmentLcy: z.number().min(0),
    isBalancingEntity: z.boolean(),
    lpFeeTemplateId: z.string().optional().nullable(),
    carriedInterestFeeTemplateId: z.string().optional(),
    equalisationInterestFeeTemplateId: z.string().optional(),
  })
  .superRefine(validateCommitmentAmount);

export const UpdateCommitment = z
  .object({
    commitmentId: z.string().refine(isMongoId()),
    vehicleId: z.string().refine(isMongoId()),
    investorId: z.string().refine(isMongoId()),
    commitmentDate: z.date(),
    capitalCommitmentLcy: z.number().min(0),
    loanCommitmentLcy: z.number().min(0),
    totalCommitmentLcy: z.number().min(0),
    isBalancingEntity: z.boolean(),
    lpFeeTemplateId: z.string().optional().nullable(),
    carriedInterestFeeTemplateId: z.string().optional().nullable(),
    equalisationInterestFeeTemplateId: z.string().optional().nullable(),
    externalCommitmentId: z.string().optional().nullable(),
    investorCurrency: z.nativeEnum(CurrencyCode),
  })
  .superRefine(validateCommitmentAmount);

export const ListCommitments = withPaginationParams(
  z.object({
    investorName: z.string().optional(),
    pendingClose: z.boolean().optional(),
    onlyEqualised: z.boolean().optional(),
    startDate: z.custom<CalendarDay>().optional(),
    endDate: z.custom<CalendarDay>().optional(),
  }),
  ['investorName', 'commitmentDate', 'isBalancingEntity', 'totalCommitmentLcy'],
);
